import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./Footer.css";
import "./ResponsiveFooter.css";
import logo from "../../assets/logo.svg";
import { FaHeart, FaApple, FaGooglePlay } from "react-icons/fa";
import { AppDownloadModal } from "../common/AppDownloadModal";

const APPLE_STORE_URL = "https://apps.apple.com/pl/app/sharecipe/id6470614602";
const GOOGLE_PLAY_URL = "https://play.google.com/store/apps/details?id=com.sharecipe";

export const Footer = () => {
  const [isAppModalOpen, setIsAppModalOpen] = useState(false);
  const navigate = useNavigate();

  return (
    <footer className="footer-section">
      <div className="footer-container">
        {/* Brand Header */}
        <div className="footer-brand">
          <div className="footer-logo-wrapper" onClick={() => navigate('/')} style={{ cursor: 'pointer' }}>
            <img src={logo} alt="ShareRecipe" className="footer-logo" />
          </div>
          <p className="footer-tagline">
            Discover & Join Recipe Clubs. Share your passion for healthy, delicious home cooking with a vibrant community.
          </p>
        </div>

        {/* Centered Navigation Pill Buttons */}
        <div className="footer-nav-buttons">
          <Link to="/" className="footer-btn">
            Home
          </Link>
          <Link to="/recipes" className="footer-btn">
            Healthy Recipes
          </Link>
          <Link to="/clubs" className="footer-btn highlight-btn">
            Recipe Clubs
          </Link>
          <button 
            type="button" 
            className="footer-btn modal-btn" 
            onClick={() => setIsAppModalOpen(true)}
          >
            Get App
          </button>
          <a 
            href={APPLE_STORE_URL} 
            target="_blank" 
            rel="noopener noreferrer" 
            className="footer-btn app-store-btn"
          >
            <FaApple /> App Store
          </a>
          <a 
            href={GOOGLE_PLAY_URL} 
            target="_blank" 
            rel="noopener noreferrer" 
            className="footer-btn play-store-btn"
          >
            <FaGooglePlay /> Google Play
          </a>
        </div>

        {/* Legal Links */}
        <div className="footer-legal-links">
          <Link to="/privacy">Privacy Policy</Link>
          <span className="dot-divider">•</span>
          <Link to="/terms">Terms & Conditions</Link>
        </div>

        {/* Bottom Bar */}
        <div className="footer-bottom-bar">
          <p className="copyright-text">
            &copy; {new Date().getFullYear()} ShareRecipe. All Rights Reserved.
          </p>
          <p className="crafted-text">
            Crafted with <FaHeart className="heart-icon" /> for food lovers everywhere.
          </p>
        </div>
      </div>

      <AppDownloadModal 
        isOpen={isAppModalOpen}
        onClose={() => setIsAppModalOpen(false)}
        title="Download ShareRecipe App"
      />
    </footer>
  );
};
